/**
 * FANTTER Theme JavaScript — v2.0
 * Fixes: gallery thumbnails, cart AJAX, buy now, product options
 */
'use strict';

const $ = (sel, ctx = document) => ctx.querySelector(sel);
const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
const formatMoney = cents => {
  if (!cents && cents !== 0) return '';
  return (cents / 100).toLocaleString('es-CO', { minimumFractionDigits: 0 }) + ' COP';
};

/* ─── TOAST ─────────────────────────────────────── */
const Toast = {
  el: null, timer: null,
  init() { this.el = $('#ToastNotification'); },
  show(msg, type = 'success', ms = 3200) {
    if (!this.el) return;
    this.el.textContent = (type === 'success' ? '✓ ' : '✕ ') + msg;
    this.el.className = `toast toast--${type} is-visible`;
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.el.classList.remove('is-visible'), ms);
  }
};

/* ─── HEADER ─────────────────────────────────────── */
const Header = {
  init() {
    const el = $('.site-header');
    if (!el) return;
    window.addEventListener('scroll', () => {
      el.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }
};

/* ─── CART ──────────────────────────────────────── */
const Cart = {
  freeShipThreshold: 17500000, // default, sobreescrito por data-threshold en #CartFreeShip

  init() {
    // Leer umbral de envio gratis desde el DOM (pasado por Liquid desde theme settings)
    const freeShipEl = document.getElementById('CartFreeShip');
    if (freeShipEl && freeShipEl.dataset.threshold) {
      this.freeShipThreshold = parseInt(freeShipEl.dataset.threshold, 10);
    }
    $$('.js-cart-open').forEach(b => b.addEventListener('click', () => this.open()));
    $$('.js-cart-close').forEach(b => b.addEventListener('click', () => this.close()));
    $('.js-cart-overlay, .cart-overlay')?.addEventListener('click', () => this.close());
    $('#CartDrawerBody')?.addEventListener('click', e => {
      if (e.target.closest('.js-qty-minus')) this.changeQty(e.target.closest('.js-qty-minus').dataset.key, -1);
      if (e.target.closest('.js-qty-plus'))  this.changeQty(e.target.closest('.js-qty-plus').dataset.key,  +1);
      if (e.target.closest('.js-cart-remove')) this.removeItem(e.target.closest('.js-cart-remove').dataset.key);
    });
  },

  open()  {
    $('.cart-drawer')?.classList.add('is-open');
    $('.cart-overlay')?.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    this.refreshUI();
  },
  close() {
    $('.cart-drawer')?.classList.remove('is-open');
    $('.cart-overlay')?.classList.remove('is-active');
    document.body.style.overflow = '';
  },

  async getCart() {
    const r = await fetch('/cart.js');
    return r.json();
  },

  async add(variantId, qty = 1) {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: qty })
    });
    const data = await r.json();
    if (data.status >= 400 || data.description) throw new Error(data.description || 'Error');
    await this.refreshUI();
    return data;
  },

  async changeQty(key, delta) {
    const cart = await this.getCart();
    const item = cart.items.find(i => i.key === key);
    if (!item) return;
    const newQty = Math.max(0, item.quantity + delta);
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    });
    await this.refreshUI();
  },

  async removeItem(key) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    await this.refreshUI();
  },

  async refreshUI() {
    const cart = await this.getCart();
    this.updateBadges(cart.item_count);
    this.updateSubtotal(cart.total_price);
    this.updateFreeShip(cart.total_price);
    this.renderItems(cart);
  },

  updateBadges(count) {
    $$('.js-cart-count, .header__cart-count').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
    $$('.js-cart-count-drawer').forEach(el => el.textContent = count);
    // Update drawer title
    const title = $('.cart-drawer__title');
    if (title) title.textContent = `Tu carrito (${count})`;
  },

  updateSubtotal(cents) {
    $$('.js-cart-subtotal').forEach(el => {
      el.textContent = (cents / 100).toLocaleString('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' COP';
    });
  },

  updateFreeShip(cents) {
    const remaining = this.freeShipThreshold - cents;
    const pct = Math.min((cents / this.freeShipThreshold) * 100, 100);

    // Actualiza la barra
    const fill = $('#FreeShipFill');
    if (fill) fill.style.width = pct + '%';

    // Reconstruye texto completo cada vez — evita DOM obsoleto tras "¡Envío gratis!"
    const textWrap = $('.cart-drawer__free-ship-text');
    if (!textWrap) return;

    if (remaining <= 0) {
      textWrap.innerHTML = '🎉 <strong>¡Envío gratis aplicado!</strong>';
    } else {
      const rem = (remaining / 100).toLocaleString('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
      textWrap.innerHTML = 'Te faltan <strong id="FreeShipRemaining">$' + rem + ' COP</strong> para envío gratis 🚚';
    }
  },

  renderItems(cart) {
    const body = $('#CartDrawerBody');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = `
        <div class="cart-drawer__empty">
          <p class="cart-drawer__empty-title">Tu carrito está vacío</p>
          <p class="cart-drawer__empty-sub">Descubre nuestras colecciones</p>
          <a href="/collections/all" class="btn btn--primary js-cart-close">VER PRODUCTOS</a>
        </div>`;
      // Hide footer when empty
      const footer = $('.cart-drawer__footer');
      if (footer) footer.style.display = 'none';
      return;
    }

    const itemsHtml = cart.items.map(item => {
      const price = (item.final_price / 100).toLocaleString('es-CO', { minimumFractionDigits: 0 });
      const variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      const imgSrc = item.featured_image?.url
        ? item.featured_image.url.replace(/(\.(jpg|png|gif|webp))/, '_120x150$1')
        : '';
      return `
        <div class="cart-item" data-key="${item.key}">
          <a href="${item.url}" class="cart-item__img-link">
            ${imgSrc ? `<img src="${imgSrc}" alt="${item.title}" class="cart-item__img" loading="lazy" width="72" height="90">` : '<div class="cart-item__img"></div>'}
          </a>
          <div class="cart-item__details">
            <a href="${item.url}" class="cart-item__name">${item.product_title}</a>
            ${variantTitle ? `<p class="cart-item__variant">${variantTitle}</p>` : ''}
            <p class="cart-item__price">$${price} COP</p>
            <div class="cart-item__qty">
              <button class="qty-btn js-qty-minus" data-key="${item.key}" aria-label="Menos" type="button">−</button>
              <span class="qty-num">${item.quantity}</span>
              <button class="qty-btn js-qty-plus" data-key="${item.key}" aria-label="Más" type="button">+</button>
            </div>
          </div>
          <button class="cart-item__remove js-cart-remove" data-key="${item.key}" aria-label="Eliminar" type="button">×</button>
        </div>`;
    }).join('');

    body.innerHTML = itemsHtml;

    // Show/update footer — create it if missing (e.g. page loaded with empty cart)
    let footer = $('.cart-drawer__footer');
    if (!footer) {
      footer = document.createElement('div');
      footer.className = 'cart-drawer__footer';
      const drawer = $('#CartDrawer');
      if (drawer) drawer.appendChild(footer);
    }
    const subtotalFormatted = (cart.total_price / 100).toLocaleString('es-CO', { minimumFractionDigits: 0 });
    footer.style.display = '';
    footer.innerHTML = `
      <div class="cart-subtotal">
        <span class="cart-subtotal__label">Subtotal</span>
        <span class="cart-subtotal__price js-cart-subtotal">$${subtotalFormatted} COP</span>
      </div>
      <p class="cart-shipping-note">✓ Devoluciones gratis en 30 días</p>
      <a href="/checkout" class="btn btn--checkout">FINALIZAR COMPRA</a>
      <button class="btn btn--continue js-cart-close" type="button">SEGUIR COMPRANDO</button>`;
  }
};

/* ─── PRODUCT PAGE ──────────────────────────────── */
const ProductPage = {
  variantData: [],

  init() {
    if (!$('.product-page')) return;

    // Parse variants
    const jsonEl = $('#VariantJson');
    if (jsonEl) {
      try { this.variantData = JSON.parse(jsonEl.textContent); } catch(e) {}
    }

    // Gallery thumbnails
    $('#GalleryThumbs')?.addEventListener('click', e => {
      const thumb = e.target.closest('.product-gallery__thumb');
      if (!thumb) return;
      const src = thumb.dataset.src;
      const alt = thumb.dataset.alt;
      const mainImg = $('#MainProductImage');
      if (mainImg && src) {
        mainImg.src = src;
        mainImg.alt = alt || '';
      }
      $$('.product-gallery__thumb').forEach(t => {
        t.classList.remove('is-active');
        t.setAttribute('aria-pressed', 'false');
      });
      thumb.classList.add('is-active');
      thumb.setAttribute('aria-pressed', 'true');
    });

    // Option swatches
    document.addEventListener('click', e => {
      const swatch = e.target.closest('[data-option-index][data-value]');
      if (!swatch || swatch.classList.contains('is-unavailable')) return;
      const optionIndex = parseInt(swatch.dataset.optionIndex);
      const value = swatch.dataset.value;
      // Update active state
      const group = swatch.closest('.product-option');
      group?.querySelectorAll('[data-value]').forEach(s => s.classList.remove('is-active'));
      swatch.classList.add('is-active');
      // Update label
      const label = $(`.js-option-value-${optionIndex}`);
      if (label) label.textContent = value;
      this.findAndSetVariant();
    });

    // Add to cart
    $('#AddToCartBtn')?.addEventListener('click', async () => {
      const btn = $('#AddToCartBtn');
      const variantId = $('#SelectedVariantId')?.value;
      if (!variantId) return;
      const origText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'AGREGANDO...';
      try {
        await Cart.add(variantId);
        Cart.open();
        Toast.show('Producto agregado al carrito');
      } catch (err) {
        Toast.show('No se pudo agregar. Intenta de nuevo.', 'error');
      } finally {
        btn.disabled = false;
        btn.textContent = origText;
      }
    });

    // Buy now
    $('#BuyNowBtn')?.addEventListener('click', async () => {
      const btn = $('#BuyNowBtn');
      const variantId = $('#SelectedVariantId')?.value;
      if (!variantId) return;
      const origText = btn.textContent.trim();
      btn.disabled = true;
      btn.textContent = 'PROCESANDO...';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || 'Error al agregar');
        }
        // Use /cart/checkout to ensure Shopify processes correctly
        window.location.href = '/checkout';
      } catch(err) {
        btn.disabled = false;
        btn.textContent = origText;
        Toast.show(err.message || 'Error al procesar. Intenta de nuevo.', 'error');
      }
    });

    // Wishlist
    $('.js-add-wishlist')?.addEventListener('click', e => {
      const btn = e.currentTarget;
      btn.classList.toggle('is-wished');
      Toast.show(btn.classList.contains('is-wished') ? 'Guardado en favoritos ♡' : 'Eliminado de favoritos');
    });

    // Size guide
    document.addEventListener('click', e => {
      if (e.target.closest('.js-size-guide')) SizeModal.open();
    });

    // Upsell add
    document.addEventListener('click', async e => {
      const btn = e.target.closest('.js-upsell-add');
      if (!btn) return;
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.disabled = true;
      try {
        await Cart.add(variantId);
        Cart.open();
        Toast.show('Producto agregado al carrito');
      } catch {
        Toast.show('No disponible', 'error');
      } finally {
        btn.disabled = false;
      }
    });
  },

  findAndSetVariant() {
    if (!this.variantData.length) return;

    // Collect current selections
    const selectedOptions = [];
    $$('.product-option').forEach(group => {
      const active = group.querySelector('[data-value].is-active');
      selectedOptions.push(active ? active.dataset.value : null);
    });

    // Find matching variant
    const variant = this.variantData.find(v =>
      selectedOptions.every((opt, i) => !opt || v[`option${i + 1}`] === opt)
    );
    if (!variant) return;

    // Update hidden input + buttons
    const hiddenInput = $('#SelectedVariantId');
    if (hiddenInput) hiddenInput.value = variant.id;

    // Price
    const priceEl = $('#ProductPrice');
    if (priceEl) {
      if (variant.compare_at_price > variant.price) {
        const discount = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        priceEl.innerHTML = `
          <span class="price price--sale">${(variant.price / 100).toLocaleString('es-CO')} COP</span>
          <span class="price price--compare">${(variant.compare_at_price / 100).toLocaleString('es-CO')} COP</span>
          <span class="price__badge">-${discount}%</span>`;
      } else {
        priceEl.innerHTML = `<span class="price">${(variant.price / 100).toLocaleString('es-CO')} COP</span>`;
      }
    }

    // ATC & BuyNow
    const atcBtn = $('#AddToCartBtn');
    const buyBtn = $('#BuyNowBtn');
    if (atcBtn) {
      if (variant.available) {
        atcBtn.disabled = false;
        atcBtn.textContent = `AGREGAR AL CARRITO — ${(variant.price / 100).toLocaleString('es-CO')} COP`;
      } else {
        atcBtn.disabled = true;
        atcBtn.textContent = 'AGOTADO';
      }
    }
    if (buyBtn) buyBtn.style.display = variant.available ? '' : 'none';

    // Inventory tracker update
    const badge     = $('#InvBadge');
    const invText   = $('#InvText');
    const barWrap   = $('#InvBarWrap');
    const barFill   = $('#InvBarFill');
    const barCount  = $('#InvBarCount');
    const urgency   = $('#InvUrgency');

    // Read thresholds from data attrs on tracker (set by Liquid)
    const tracker   = $('#InvTracker');
    const thrLow    = tracker ? parseInt(tracker.dataset.thrLow  || 5,  10) : 5;
    const thrMid    = tracker ? parseInt(tracker.dataset.thrMid  || 20, 10) : 20;
    const barMax    = tracker ? parseInt(tracker.dataset.barMax  || 50, 10) : 50;
    const urgencyTpl= tracker ? (tracker.dataset.urgencyTpl || '') : '';
    const showCount = tracker ? tracker.dataset.showCount === 'true' : true;

    const qty  = variant.inventory_quantity;
    const avail = variant.available;

    if (badge && invText) {
      // Remove all level classes
      badge.className = 'inv-badge';
      if (!avail) {
        badge.classList.add('inv-badge--out');
        invText.textContent = 'Agotado';
      } else if (qty > 0 && qty <= thrLow) {
        badge.classList.add('inv-badge--low');
        invText.textContent = `Solo ${qty} unidad${qty !== 1 ? 'es' : ''} disponible${qty !== 1 ? 's' : ''}`;
      } else if (qty > thrLow && qty <= thrMid) {
        badge.classList.add('inv-badge--mid');
        invText.textContent = 'Pocas unidades disponibles';
      } else {
        badge.classList.add('inv-badge--ok');
        invText.textContent = 'Disponible';
      }
      // Update dot
      const dot = badge.querySelector('.inv-dot');
      if (dot) {
        dot.className = 'inv-dot';
        if (!avail)           dot.classList.add('inv-dot--out');
        else if (qty <= thrLow) dot.classList.add('inv-dot--low');
        else if (qty <= thrMid) dot.classList.add('inv-dot--mid');
        else                  dot.classList.add('inv-dot--ok');
      }
    }

    // Bar
    if (barWrap) {
      if (!avail || qty <= 0) {
        barWrap.style.display = 'none';
      } else {
        barWrap.style.display = '';
        if (barFill) {
          const pct = Math.min(100, Math.round(qty * 100 / barMax));
          barFill.style.width = pct + '%';
          barFill.removeAttribute('data-level');
          if      (qty <= thrLow) barFill.dataset.level = 'low';
          else if (qty <= thrMid) barFill.dataset.level = 'mid';
        }
        if (barCount && showCount) {
          barCount.style.display = '';
          if (qty <= thrMid) {
            barCount.textContent = `${qty} de ${barMax}`;
          } else {
            barCount.textContent = `${barMax}+ disponibles`;
          }
        } else if (barCount) {
          barCount.style.display = 'none';
        }
      }
    }

    // Urgency
    if (urgency) {
      if (avail && qty > 0 && qty <= thrLow && urgencyTpl) {
        urgency.textContent = urgencyTpl.replace('{{qty}}', qty);
        urgency.style.display = '';
      } else {
        urgency.style.display = 'none';
      }
    }

    // Update URL
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }
};

/* ─── QUICK ADD (cards) ─────────────────────────── */
const QuickAdd = {
  init() {
    document.addEventListener('click', async e => {
      const btn = e.target.closest('.js-quick-add');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      const orig = btn.textContent;
      btn.disabled = true;
      btn.textContent = '...';
      try {
        await Cart.add(variantId);
        Cart.open();
        Toast.show('Producto agregado al carrito');
      } catch {
        Toast.show('Selecciona opciones primero', 'error');
      } finally {
        btn.disabled = false;
        btn.textContent = orig;
      }
    });

    document.addEventListener('click', e => {
      const btn = e.target.closest('.js-wishlist-btn');
      if (!btn) return;
      e.preventDefault();
      btn.classList.toggle('is-active');
      const wished = btn.classList.contains('is-active');
      btn.textContent = wished ? '♥' : '♡';
      Toast.show(wished ? 'Guardado en favoritos' : 'Eliminado de favoritos');
    });
  }
};

/* ─── SIZE MODAL ────────────────────────────────── */
const SizeModal = {
  el: null,
  init() {
    this.el = $('#SizeModal');
    $$('.js-size-modal-close').forEach(el => el.addEventListener('click', () => this.close()));
    document.addEventListener('keydown', e => { if (e.key === 'Escape') this.close(); });
  },
  open()  { this.el?.classList.add('is-open'); this.el?.removeAttribute('aria-hidden'); },
  close() { this.el?.classList.remove('is-open'); this.el?.setAttribute('aria-hidden', 'true'); }
};

/* ─── MOBILE NAV ────────────────────────────────── */
const MobileNav = {
  el: null,
  init() {
    this.el = $('#MobileNav');
    if (!this.el) return;

    // Open triggers — hamburger button
    $$('.js-mobile-nav-open').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.open();
      });
    });

    // Close triggers — overlay and X button
    $$('.js-mobile-nav-close').forEach(el => {
      el.addEventListener('click', () => this.close());
    });

    // Escape key
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && this.el.classList.contains('is-open')) this.close();
    });
  },

  open() {
    if (!this.el) return;
    this.el.classList.add('is-open');
    this.el.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
    $$('.js-mobile-nav-open').forEach(b => b.setAttribute('aria-expanded', 'true'));
  },

  close() {
    if (!this.el) return;
    this.el.classList.remove('is-open');
    this.el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    $$('.js-mobile-nav-open').forEach(b => b.setAttribute('aria-expanded', 'false'));
  }
};

/* ─── SEARCH OVERLAY ────────────────────────────── */
const SearchOverlay = {
  el: null,
  init() {
    this.el = $('#SearchOverlay');
    $$('.js-search-toggle').forEach(b => b.addEventListener('click', () => this.open()));
    $$('.js-search-close').forEach(b => b.addEventListener('click', () => this.close()));
    document.addEventListener('keydown', e => { if (e.key === 'Escape') this.close(); });
  },
  open()  { this.el?.classList.add('is-open'); setTimeout(() => $('#SearchInput')?.focus(), 80); },
  close() { this.el?.classList.remove('is-open'); }
};

/* ─── SORT (collection page) ───────────────────── */
const CollectionSort = {
  init() {
    const sel = $('.js-sort-by');
    if (!sel) return;
    sel.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      window.location.href = url.toString();
    });
    // Set current value from URL
    const current = new URL(window.location.href).searchParams.get('sort_by');
    if (current) sel.value = current;
  }
};

/* ─── SCROLL ANIMATIONS ─────────────────────────── */
const Animations = {
  init() {
    const targets = $$('.animate-in');
    if (!targets.length || !('IntersectionObserver' in window)) {
      targets.forEach(el => el.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); observer.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    targets.forEach(el => observer.observe(el));
  }
};

/* ─── INIT ──────────────────────────────────────── */
/* ─── ACCORDION (global — works on all pages) ──── */
document.addEventListener('click', function(e) {
  var trigger = e.target.closest('.js-accordion');
  if (!trigger) return;
  var body = trigger.nextElementSibling;
  if (!body) return;
  var icon = trigger.querySelector('.accordion__icon');
  var open = body.classList.toggle('is-open');
  trigger.setAttribute('aria-expanded', open);
  if (icon) icon.textContent = open ? '−' : '+';
});

/* ─── MOBILE NAV (global event delegation — defer-safe) ── */
document.addEventListener('click', function(e) {
  var nav = document.getElementById('MobileNav');
  if (!nav) return;

  // Open
  if (e.target.closest('.js-mobile-nav-open')) {
    nav.classList.add('is-open');
    nav.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
    return;
  }
  // Close
  if (e.target.closest('.js-mobile-nav-close')) {
    nav.classList.remove('is-open');
    nav.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    return;
  }
});

document.addEventListener('keydown', function(e) {
  if (e.key !== 'Escape') return;
  var nav = document.getElementById('MobileNav');
  if (nav && nav.classList.contains('is-open')) {
    nav.classList.remove('is-open');
    nav.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
});

// Works with both defer and non-defer loading
function fantterInit() {
  Toast.init();
  Header.init();
  Cart.init();
  QuickAdd.init();
  SizeModal.init();
  MobileNav.init();
  SearchOverlay.init();
  ProductPage.init();
  CollectionSort.init();
  Animations.init();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', fantterInit);
} else {
  fantterInit();
}

/* ── MOBILE LOGO POSITION ── */
(function() {
  const wrap = document.querySelector('.header__logo-wrap');
  if (!wrap) return;
  // Read data attribute set by Liquid
  const mobilePos = wrap.dataset.mobilePos || 'center';
  if (window.innerWidth <= 900) {
    wrap.classList.add(`header__logo-wrap--mobile-${mobilePos}`);
  }
  window.addEventListener('resize', () => {
    wrap.classList.remove('header__logo-wrap--mobile-left','header__logo-wrap--mobile-center','header__logo-wrap--mobile-right');
    if (window.innerWidth <= 900) wrap.classList.add(`header__logo-wrap--mobile-${mobilePos}`);
  });
})();
